const trackingUtils = require('od-modules/utils/tracking.utils');

const MYTRIPS_PAGE = 'mytrips';
const CONF_PAGE = 'confirmation';
const DEFAULT_AGE = 25;

module.exports = {
    isMyTripsHome() {
        if (Odigeo.History.getPageNameFromFragment() === MYTRIPS_PAGE) {
            const urlArray = Odigeo._.result(Odigeo.History, 'getFragment', '').split('/');
            const firstChar = Odigeo._.last(urlArray).charAt(0);

            return !Odigeo._.isFinite(parseInt(firstChar));
        }

        return null;
    },

    isConfirmationPage() {
        return Odigeo.History.getPageNameFromFragment().toLowerCase() === CONF_PAGE;
    },

    isAccomodationPostBooking() {
        return Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));
    },

    getPassengers(travellers) {
        let paxGroups = Odigeo._.groupBy(
            travellers, Odigeo._.get(travellers, '[0].ageType') === undefined ? 'travellerType' : 'ageType');

        return {
            numAdults: Odigeo._.size(paxGroups.ADULT),
            numChildren: Odigeo._.size(paxGroups.CHILD),
            numInfants: Odigeo._.size(paxGroups.INFANT),
        };
    },

    getFormattedDate(timestamp, format) {
        const date = new Date(timestamp);
        const formattedDate = Odigeo.Utils.formatDate(date, format, true);

        return formattedDate;
    },

    getEncodedDate(timestamp, format) {
        const formattedDate = this.getFormattedDate(timestamp, format);

        return encodeURIComponent(formattedDate);
    },

    openLink(url) {
        if (isSameDomain(url)) {
            openInternalLink(url);
        } else {
            trackingUtils.openExternalLink(url);
        }
    },

    getAge(timestamp) {
        return timestamp ? Odigeo.Utils.getAge(timestamp) : DEFAULT_AGE;
    },

    isOneDayTrip(arrivalTimestamp, departureTimestamp) {
        const arrivalDate = new Date(arrivalTimestamp);
        const departureDate = new Date(departureTimestamp);

        return arrivalDate.getDate() === departureDate.getDate() && arrivalDate.getMonth() === departureDate.getMonth();
    },

    isRedirectionFromConfirmation(bookingId) {
        const idFromConfirmation = Odigeo.Utils.parseJson(Odigeo.Session.get('isRedirectionFromConfirmation'));
        const isRedirection = (idFromConfirmation && bookingId) ? idFromConfirmation === bookingId : false;
        switch (Odigeo.SessionScope.flow) {
            case 'desktop':
                return isRedirection && Odigeo.AB.confirmationMytripsAutomaticRedirection === 3;
            case 'mobile':
                return isRedirection && Odigeo.AB.confirmationMytripsAutomaticRedirectionMobile === 3;
            default:
                return false;
        }
    },

    getCurrentDate() {
        return new Date();
    },

    isHotelsActive(itinerary) {
        return Odigeo.CrossSelling.isHotelsActive && !itinerary.hasHotelBooked() && !itinerary.isSameDayReturn() &&
            !this.isAccomodationPostBooking();
    },

    navigateToNonSecure(pageName, hasParams = null) {
        const pathNames = Odigeo.Settings.getProperty('pathNames');
        const protocol = location.protocol;
        const hostname = location.hostname;
        const locationPort = location.port ? `:${location.port}` : '';
        const path = pathNames[Odigeo.Router.getApp('home')];
        const hash = '#/' + pageName + '/';
        const params = hasParams ? 'isAccommodationPostBookingCoSearch=true;' : '';
        location.href = `${protocol}//${hostname}${locationPort}${path}${hash}${params}`;
    },

    removeHotelFromShoppingCart(isChangeHotel) {
        Odigeo.requireWidget('shoppingcart-manager', 'shoppingcartmanager', function(shoppingcartManager) {
            shoppingcartManager.execute('deleteHotelFromCart', isChangeHotel);
        });
    },

    showRemoveHotelNag: function(imgUrl, removeHotelHandler, changeHotelHandler) {
        const {shouldChangeHtml, changeHotelLinkHtml, loadingContentContainerHtml} = getRemoveHotelNagHtmlSections();

        const hideRemoveHotelNag = function() {
            Odigeo.UIElements.hideDialog($('.remove_hotel_nag'));
        };

        Odigeo.UIElements.showNagPopup('od-nag-remove-hotel remove_hotel_nag',
            Odigeo.UIElements.translations.xsellIntermediatePage.removeHotel,
            removeHotelHandler,
            hideRemoveHotelNag,
            {
                appearances: 'remove_hotel_appearances',
                add: 'remove_hotel_remove',
                skip: 'remove_hotel_keep',
            },
            shouldChangeHtml.outerHtml() + ' ' + changeHotelLinkHtml.outerHtml(),
            loadingContentContainerHtml.outerHtml(),
            true
        );

        $('.remove_hotel_nag .dialog_box_header').css({
            'background-image': 'url(' + imgUrl + ')',
        });
        $('.remove_hotel_nag_change_hotel').on(Odigeo.Events.tap, changeHotelHandler);
    },
};

function getRemoveHotelNagHtmlSections() {
    const {
        alternative: shouldChangeText,
        changeHotel: changeHotelLinkText,
        loadingMessage: loadingContentText,
    } = Odigeo.UIElements.translations.xsellIntermediatePage.removeHotel;
    const loadingContentHtml = $('<span>', {'class': 'odf-text odf-text-sm', 'text': loadingContentText});
    const shouldChangeHtml = $('<span>', {'class': 'odf-text odf-text-sm', 'text': shouldChangeText});
    const changeHotelLinkHtml = $('<span>', {
        'class': 'odf-link odf-link-sm remove_hotel_nag_change_hotel',
        'text': changeHotelLinkText,
    });
    const spinnerHtml = $('<div>',
        {'class': 'odf-loading-rounded odf-loading-rounded-sm odf-loading-rounded-informative od-loading-spinner'})
        .append($('<div>', {'class': 'odf-loading-rounded-container'})
            .append($('<svg>', {'class': 'odf-path-container', 'viewBox': '0 0 100 100'})
                .append($('<path>', {
                    'class': 'odf-loading-rounded-track',
                    'd': 'M 50,50 m 0,-44.5 a 44.5,44.5 0 1 1 0,89 a 44.5,44.5 0 1 1 0,-89',
                }))
                .append($('<path>', {
                    'class': 'odf-loading-rounded-head',
                    'd': 'M 94.5 50 A 44.5 44.5 0 0 0 50 5.5',
                }))
            )
        );
    const loadingContentContainerHtml = $('<div>', {'class': 'odf-hidden od-dialog-content-container dialog_content_container'})
        .append(spinnerHtml)
        .append(loadingContentHtml);
    return {shouldChangeHtml, changeHotelLinkHtml, loadingContentContainerHtml};
}

function isSameDomain(url) {
    return Odigeo._.includes(url, Odigeo.CrossSelling.mainDomain) || Odigeo._.startsWith(url, '#');
}

function openInternalLink(url) {
    window.open(url);
}
